import BCA from '@/assets/store/icon/bank-bca.svg';
import BCA_DIGITAL from '@/assets/store/icon/bank-bca-digital.svg';
import BNI from '@/assets/store/icon/bank-bni.svg';
import BRI from '@/assets/store/icon/bank-bri.svg';
import CIMB from '@/assets/store/icon/bank-cimb.svg';
import DANA from '@/assets/store/icon/bank-dana.svg';
import GOPAY from '@/assets/store/icon/bank-gopay.svg';
import LINKAJA from '@/assets/store/icon/bank-linkaja.svg';
import MANDIRI from '@/assets/store/icon/bank-mandiri.svg';
import MAYBANK from '@/assets/store/icon/bank-maybank.svg';
import OVO from '@/assets/store/icon/bank-ovo.svg';

// By DOKU bank code, as the BANK and EWALLET cm_code groups hold it
const LOGOS: Record<string, string> = {
  '002': BRI,
  '008': MANDIRI,
  '009': BNI,
  '014': BCA,
  '016': MAYBANK,
  '022': CIMB,
  '501': BCA_DIGITAL,
  GOPAY,
  DANA,
  OVO,
  '911': LINKAJA,
};

/** Bundled logo URL; undefined for a bank without one. */
export const bankLogoByCode = (code: string): string | undefined => LOGOS[code];
